import React, { useState, useEffect } from 'react';
import Header from '../common/layout/header';
import Footer from '../common/layout/footer';
import Sidebar from '../common/sidebar';
import { BaseUrl } from '../common/config';
import { http } from '../helper';
import CommonAlert from '../common/Commonalert';
import ShowAlert from '../common/Showalert';
import Select from 'react-select';
import { useTranslation } from "react-i18next";
const ChefAccountcodeAdd = () => {
  const { t } = useTranslation();
  const [accountCodeOptions, setAccountCodeOptions] = useState([]);
  const [selectedCodes, setSelectedCodes] = useState([]);
  const [errMessage, setErrMessage] = useState('');
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [restrictedCodeSet, setRestrictedCodeSet] = useState(new Set());
  const [inputValue, setInputValue] = useState('');
  const [isLoading, setIsLoading] = useState(true); 
  // Redirect unauthenticated or unauthorized users
  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = '/';
  }
  if (JSON.parse(sessionStorage.getItem('authData')) !== '' &&
    !JSON.parse(sessionStorage.getItem('authData')).adminRole.permissions.includes('manage_chefs')) {
    window.location.href = '/unauthorized';
  }
  // Fetch account code options
  useEffect(() => {
    const fetchCodes = async () => {
      setIsLoading(true);
        try {
        // Fetch all account codes and already added (restricted) ones
        const [allRes, restrictedRes, chefsRes] = await Promise.all([
            http.get(`${BaseUrl}admin/account`),
            http.get(`${BaseUrl}admin/chefaccountcodelist`),
            http.get(`${BaseUrl}admin/getchefs`)
        ]);
        const allCodes = allRes.data.data || [];
        const restrictedCodes = restrictedRes.data.data || [];
        const chefsList = chefsRes.data.data || [];
        // normalize
      const normalize = (val) => val?.toLowerCase()?.trim();
        // Build a Set of restricted account codes
        const restrictedSet = new Set(
            restrictedCodes.map(item => item.accountCode?.toLowerCase())
        );
        setRestrictedCodeSet(restrictedSet);
        // Chef group account codes (PRIMARY + SUB ACCOUNTS)
        const chefAccountSet = new Set();
        chefsList.forEach(group => {
          // Primary account
          if (group.primaryAccount?.accountCode) {
            chefAccountSet.add(
              normalize(group.primaryAccount.accountCode)
            );
          }
          // Sub accounts
          (group.accounts || []).forEach(acc => {
            if (acc.accountCode) {
              chefAccountSet.add(
                normalize(acc.accountCode)
              );
            }
          });
        });
        // Filter only those not already added
        const availableCodes = allCodes.filter(item => {
          const code = item.accountCode?.toLowerCase();
            return (!restrictedSet.has(code) && !chefAccountSet.has(code));
        });

        setAccountCodeOptions(availableCodes);
        setIsLoading(false);
        } catch (err) {
        console.log(err);
        setIsLoading(false);
        }
    };
    fetchCodes();
  }, []);
  // Redirect on cancel
  const handleCancel = (e) => {
    e.preventDefault();
    window.location.href = '/chef/accountcode';
  };
  // Form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setInputValue(''); // clear invalid typed value
    if (selectedCodes.length === 0) {
      setErrMessage(t('please_select_at_least_one_account_txt'));
      return;
    }

    const payload = {
      selectedAccountCodes: selectedCodes
    };
    setIsLoading(true);
    http.post(`${BaseUrl}admin/addchefaccountcode`, payload)
      .then(res => {
        if (res.data.success) {
          setAlertPopup(true);
          setIsLoading(false);
          setAlertMessage(t('acc_code_added_success_txt'));
          setTimeout(() => {
          window.location.href = '/chef/accountcode';
        }, 1500);
        } else {
          setErrorPopup(true);
          setErrorMessage(t("failed_add_account_txt"));
        }
      }).catch(err => {
        setErrorPopup(true);
        setErrorMessage('Something went wrong while submitting.');
        console.log(err);
      });
  };

  const customNoOptionsMessage = () => {
  const input = inputValue.trim().toLowerCase();
  if (restrictedCodeSet.has(input)) {
    return null; // Do not show any message if it's a restricted code
  }
  if (input.length > 0) {
    return t("no_options_txt");
  }
  return null;
  };

  return (
    <>
      {errorPopup && <ShowAlert title={t("error_txt")} message={errorMessage} />}
      {alertPopup && <CommonAlert title={t("alert_txt")} message={alertMessage} />}
      <div className="dashboard-block">
        <Sidebar />
        <div className="dash-left">
          <Header />
          <section className="cart-block">
            <div className="container">
              <h1 className="checkout-title vi">{t("add_account_code_txt")}</h1>
              <div className="right-table-outer-wrap">
                {isLoading  ? (
                  <div className='loading-buffer'></div>
              ):(
                <form 
                  method="post" 
                  className="addform form-container-xs"
                  onSubmit={handleSubmit}
                >
                  <div className='input-field col-1'>
                    <label>{t("account_code_txt")}</label>
                    <Select
                      isMulti
                      closeMenuOnSelect={false}
                      noOptionsMessage={customNoOptionsMessage}
                      value={accountCodeOptions
                        .filter(opt => selectedCodes.includes(opt.accountCode))
                        .map(opt => ({
                          value: opt.accountCode,
                          label: `${opt.accountCode}`
                        }))}
                      onChange={(selectedOptions) => {
                        const codes = selectedOptions.map(item => item.value);

                        // No need to re-check restricted here, handled in input validation
                        setSelectedCodes(codes);
                        setInputValue('');
                        if (codes.length > 0) setErrMessage('');
                      }}
                      onInputChange={(value, { action }) => {
                        // Handle only 'input-change' and 'input-blur'
                        if (action === 'input-change') {
                          setInputValue(value);

                          const pastedCode = value.trim().toLowerCase();

                          if (restrictedCodeSet.has(pastedCode)) {
                            setErrMessage(t("account_already_exist_txt"));
                          } else {
                            setErrMessage('');
                          }
                        }
                      }}
                      
                      inputValue={inputValue}
                      options={accountCodeOptions.map(opt => ({
                        value: opt.accountCode,
                        label: `${opt.accountCode}`
                      }))}
                      className="form-control"
                      placeholder={t("select_acc_code_txt")}
                      styles={{
                        menu: (base) => ({
                          ...base,
                          position: 'relative',
                          zIndex: 2
                        })
                      }}
                    />
                    {errMessage && <div className="error-msg">{errMessage}</div>}
                  </div>

                  <button type="submit"  onMouseDown={(e) => e.preventDefault()}>{t("submit_txt")}</button>&nbsp;&nbsp;
                  <button onClick={handleCancel}>{t("cancel_txt")}</button>
                </form>
                )}
              </div>
                    
            </div>
          </section>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default ChefAccountcodeAdd;
